<a
  *transloco="let t; prefix: scope()"
  class="flex items-center gap-1 rounded-3xl p-2 font-normal text-steel-100 shadow-none transition-shadow duration-500 ease-out hover:text-blue-50 hover:shadow-md lg:gap-2 lg:!no-underline"
  routerLink="/search"
>
  <rma-icon glyph="search" theme="primary" />
  <span class="sr-only lg:not-sr-only">{{ t('search') }}</span>
  <rma-icon class="!hidden lg:!inline-flex" glyph="chevron_right" theme="primary" />
</a>
